import styled from "styled-components"

const Title = styled.h2`

  &::after {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  color: ${(props) => props.theme.c_color_gradients.c_dark};
}
`

const ListEventsContainer = styled.div`
  border-left: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
`

export { Title, ListEventsContainer }
